import { useMemo } from "react";

import { CbhFeatureFlag } from "../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../FeatureFlags/useCbhFlag";

/**
 * Returns Set of qualifications that are auto approved, which means they don't require a license to pick up shifts.
 */
export function useAutoApprovedQualifications() {
  const rawConfig = useCbhFlag(CbhFeatureFlag.HCP_LICENSE_DEFAULT_STATUS, {
    defaultValue: {
      activeStatusRules: [
        {
          qualification: [],
        },
      ],
    },
  });

  return useMemo(() => {
    return new Set(rawConfig.activeStatusRules.flatMap((rule) => rule.qualification));
  }, [rawConfig]);
}
